import styled from "styled-components";
import MaintenanceOrderServiceTime from "./MaintenanceOrderServiceTime";
import { BsHourglassSplit } from "react-icons/bs";
import { useGetWiToolAssetsWithRules } from "./useGetWiToolAssetsWithRules";

const StyledModal = styled.div`
  display: flex;
  flex-direction: column;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  justify-content: start;
  gap: 1rem;
  padding: 1rem;
  box-sizing: border-box;
`;

const OrderContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 40rem;
  align-content: flex-start;
  min-height: 10rem;
  height: auto;
  padding: 2rem;
  background-color: "var(--backdrop-color-ex)";
  backdrop-filter: blur(10px);
  box-shadow: var(--shadow-div-md);
  border-radius: 1rem;
  margin-bottom: 1.5rem;
`;

const ServiceTimeContainer = styled.div`
  display: flex;
  width: 60rem;
  align-content: flex-start;
  min-height: 10rem;
  height: auto;
  padding: 2rem;
  background-color: ${(props) =>
    props.$type === "current"
      ? "var(--backdrop-color-ex)"
      : "var(--backdrop-color)"};
  backdrop-filter: blur(10px);
  box-shadow: var(--shadow-div-md);
  border-radius: 1rem;
  margin-bottom: 1.5rem;
`;

const StyledState = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4em;
`;

const StyledAssetGroup = styled.h4`
  color: var(--color-grey-500);
  white-space: nowrap;
`;

const StateCircle = styled.span`
  background-color: ${(props) => getStateColor(props.$state)};
  border-radius: 50%;
  width: 1em;
  height: 0.8em;
  display: inline-block;
`;

const OrderLink = styled.a`
  color: var(--color-primary);
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const StateText = styled.span`
  font-size: 1em;
  color: var(--color-grey-800);
`;

const StyledIdent = styled.h4`
  color: var(--color-grey-500);
`;

const PlanningDays = styled.span`
  color: red;
  font-size: 0.8em;
  margin-left: 1em;
`;

const StyledDescription = styled.h5`
  font-weight: 100;
  color: ${(props) =>
    props.$type === "failed"
      ? "var(--color-grey-600)"
      : "var(--color-grey-800)"};
  margin-top: ${(props) => (props.$type === "failed" ? "1em" : null)};
  overflow-y: auto;
  max-height: calc(1.2em * 10);
  line-height: 1.2em;
  display: -webkit-box;
  -webkit-line-clamp: 10;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
`;

const getStateColor = (state) => {
  switch (state) {
    case "Completed":
      return "#337d33";
    case "Finished":
      return "#00cc99";
    case "In Process":
      return "#95de75";
    case "Released":
      return "#fbec9b";
    case "Planned":
      return "#a4bfff";

    default:
      return "black";
  }
};

function MaintenanceOrderDetail({ item }) {
  const partsAfterDash = item.orderIdent.split("-")[1] || "";
  const orderId = partsAfterDash.replace(/^0+/, "");
  const orderLink = `https://tools.witron.com/Live/REMAVinterbro/MaintenanceExcellence/Orders.aspx/${orderId}`;

  const { data: assetsData } = useGetWiToolAssetsWithRules();

  const assetGroups = item.assetGroupString
    ? item.assetGroupString
        .split(",")
        .map((group) => {
          const trimmedGroup = group.trim();

          // Ensure we're accessing assetsData.data (an array)
          const matchedAsset = assetsData?.data?.find(
            (asset) => asset.assetIdent === trimmedGroup
          );

          if (!matchedAsset) {
            console.warn(`No matching asset found for group: ${trimmedGroup}`);
          }

          // If the group matches the content inside the parentheses, show only the group
          return matchedAsset && matchedAsset.areaDescription === trimmedGroup
            ? trimmedGroup
            : matchedAsset
            ? `${trimmedGroup} (${matchedAsset.areaDescription})`
            : trimmedGroup;
        })
        .join(", ")
    : "";

  return (
    <StyledModal>
      <StyledState>
        <StateCircle $state={item.state} />
        <StateText>{item.state}</StateText>
        {item.orderId}
        <StyledIdent>
          <OrderLink href={orderLink} target="_blank" rel="noopener noreferrer">
            {item.orderIdent}
          </OrderLink>
        </StyledIdent>
        {item.planningInDays < -14 && (
          <PlanningDays>
            DAYS SINCE FIRST PLANNED:
            {item.planningInDays}
          </PlanningDays>
        )}
      </StyledState>
      {assetGroups && <StyledAssetGroup>{assetGroups}</StyledAssetGroup>}
      <GridContainer>
        <OrderContainer>
          {item.description && (
            <StyledDescription>{item.description}</StyledDescription>
          )}
          {item.descrOfFailure && (
            <StyledDescription $type="failed">
              {item.descrOfFailure}
            </StyledDescription>
          )}
        </OrderContainer>
        <ServiceTimeContainer>
          <MaintenanceOrderServiceTime orderId={item.orderId} />
        </ServiceTimeContainer>
      </GridContainer>
    </StyledModal>
  );
}

export default MaintenanceOrderDetail;
